import React from 'react'
import { useApolloClient, useMutation } from '@apollo/client'
import { T } from '@transifex/react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { message } from 'src/antd'

import { GET_ME, MUTATION_LOGIN } from 'src/api'
import { setUser } from 'src/reactive-variables'

import UI, { FormSchema } from './ui'
import AuthLayout from '../../../components/layout/auth/AuthLayout'
import { useRouting } from '../../../reducers/routing/child-router-factory'

const Login = () => {
  const [loginMutationQuery] = useMutation(MUTATION_LOGIN)
  const client = useApolloClient()
  const history = useHistory()
  const { routingMap } = useRouting()
  const location = useLocation<$TSFixMe>()

  const getMe = async () => {
    await client.query({ query: GET_ME }).then((response) => {
      if (response.data && response.data.me) {
        setUser(response.data.me)
        if (!response.data.me.company) {
          history.push(routingMap.company.create._)
        }
      }
    })
  }

  const onSubmit = async ({ username, password, rememberMe }: FormSchema) => {
    await client.resetStore()
    const {
      data: { tokenAuth },
    } = await loginMutationQuery({
      variables: {
        username,
        password,
        rememberMe,
      },
    })

    window.localStorage.setItem('reactQLJWT', tokenAuth.token)
    window.localStorage.setItem('rememberMe', String(rememberMe))
    await getMe()
    message.success(<T _str="Success" />)
    history.push(location.state?.from || routingMap.app.dashboard)
  }

  return (
    <AuthLayout
      title={<T _str="Welcome to WasteHero!" />}
      footer={
        <>
          <T _str="Join smart waste management -" />
          &nbsp;
          <Link to="/register">
            <T _str="register now." />
          </Link>
        </>
      }
    >
      <UI onSubmit={onSubmit} formId="Login" />
    </AuthLayout>
  )
}
export default Login
